<template>
  <div>
    <div class="anchor-box" id="drag-box">
      <div
        class="orgin"
        v-drag="item"
        :style="{ top: item.pointY + '%', left: item.pointX + '%' }"
        v-for="(item, idx) in anchorList"
        :key="item.pointId"
      >
        <div
          class="anchor-item"
          :class="{ 'anchor-item-active': current == item }"
        >
          <i
            class="el-icon-error"
            v-show="current == item && !item.isSystem"
            @click="handleDel(idx)"
          ></i>
          <i
            :class="{
              'el-icon-link': item.type == 2,
              'el-icon-video-play': item.type == 1,
            }"
            @click="current = item"
          ></i>
        </div>
      </div>
      <img class="img" :src="imgInfo.url" alt="" />
    </div>

    <el-button type="primary" class="add-btn" @click="handleAdd"
      >新增资源</el-button
    >

    <el-form
      v-if="current"
      :model="current"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="资源名称" prop="title">
        <el-input
          v-model="current.title"
          placeholder="请填写资源名称"
          :disabled="current.isSystem"
        ></el-input>
      </el-form-item>
      <el-form-item label="资源类型" prop="type">
        <el-select
          v-model="current.type"
          placeholder="请选择资源类型"
          :disabled="current.isSystem"
        >
          <el-option label="链接" :value="2"></el-option>
          <el-option label="视频" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="资源链接" prop="link" v-if="current.type == 2">
        <el-input
          v-model="current.link"
          placeholder="请填写网址链接"
          :disabled="current.isSystem"
        ></el-input>
      </el-form-item>
      <el-form-item label="资源链接" prop="link" v-else>
        <el-input
          v-model="current.link"
          placeholder="请填写视频链接"
          :disabled="current.isSystem"
        >
          <el-button
            slot="append"
            icon="el-icon-folder-opened"
            @click="handleSelVideo"
          ></el-button>
        </el-input>
      </el-form-item>
    </el-form>

    <div class="btn-box">
      <el-button type="primary" @click="handleSubmit('ruleForm')"
        >提 交</el-button
      >
    </div>

    <el-dialog
      title="选择视频"
      :visible.sync="showVdeoList"
      width="50%"
      :modal="false"
    >
      <el-form :model="params" :inline="true" size="small">
        <el-form-item label="文件名称:" prop="query">
          <el-input
            v-model="params.query"
            placeholder="请输入文件名称"
          ></el-input>
        </el-form-item>
        <el-form-item class="btns">
          <el-button type="primary" @click="getAnnexList(true)">查询</el-button>
        </el-form-item>
      </el-form>

      <el-table
        class="file_list"
        :data="fileList"
        highlight-current-row
        @current-change="handleCurrentChange"
      >
        <el-table-column prop="name" label="文件名称"> </el-table-column>
        <el-table-column
          prop="createTime"
          label="上传时间"
          :formatter="formatter"
          width="200"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="type" label="类型" width="120" align="center">
        </el-table-column>
        <el-table-column prop="size" label="大小" width="120" align="center">
          <template slot-scope="scope">
            <span>{{ (scope.row.size / 1024 / 1024).toFixed(2) }}M</span>
          </template>
        </el-table-column>
      </el-table>

      <div class="foot_page">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :page-size="params.limit"
          :current-page.sync="params.page"
          :total="total"
          @current-change="getAnnexList(false)"
        ></el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { annexList } from "@/api/annex";
import { formatDate } from "@/utils/index";

export default {
  props: {
    imgInfo: Object,
    anchorList: Array,
  },
  data() {
    return {
      current: null,
      rules: {
        title: { required: true, message: "请填写资源名称", trigger: "blur" },
        type: { required: true, message: "请选择资源类型", trigger: "change" },
        link: { required: true, message: "请填写链接", trigger: "blur" },
      },
      // list: [],
      showVdeoList: false,
      params: {
        page: 1,
        limit: 10,
        classChapterId: this.$route.query.classChapterId,
        types: ["mp4", "ogg", "webm"].join(","),
        query: "",
      },
      fileList: [],
      total: 0,
    };
  },
  methods: {
    handleAdd() {
      this.anchorList.push({
        pointId: Date.now(),
        imgId: this.imgInfo.imageId,
        pointY: 50,
        pointX: 50,
        title: "",
        type: 2,
        link: "",
      });
      this.current = this.anchorList[this.anchorList.length - 1];
    },
    handleDel(idx) {
      console.log(idx);
      this.anchorList.splice(idx, 1);
      this.current = null;
    },
    handleSelVideo() {
      this.showVdeoList = true;
      this.getAnnexList();
    },
    getAnnexList(refresh) {
      if (refresh) this.params.page = 1;
      this.$loading.show();
      annexList(this.params).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.fileList = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 格式化时间
    formatter(row) {
      return formatDate(row.createTime, "YYYY-MM-DD HH:mm:ss");
    },
    handleCurrentChange(val) {
      if (val) this.current.link = val.url;
    },
    handleSubmit(formName) {
      if (!this.current) {
        this.$emit("onConfirm", this.anchorList);
        return;
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.current = null;
          this.$emit("onConfirm", this.anchorList);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.anchor-box {
  position: relative;
  width: 800px;
  height: 450px;
  line-height: 450px;
  border: dashed 1px #dcdfe6;
  user-select: none;
  overflow: hidden;
  img {
    width: 100%;
  }
}
.orgin {
  position: absolute;
  width: 1px;
  height: 1px;
  z-index: 99;

  .anchor-item {
    position: absolute;
    margin-left: -20px;
    margin-top: -20px;
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 30px;
    cursor: pointer;
    z-index: 99;
    &.anchor-item-active {
      border: solid 2px #409eff;
      border-radius: 3px;
    }
    .el-icon-error {
      position: absolute;
      right: -8px;
      top: -8px;
      font-size: 16px;
      color: #f56c6c;
    }
    .el-icon-video-play {
      color: #f56c6c;
    }
    .el-icon-link {
      color: #e6a23c;
    }
  }
}
.add-btn {
  margin: 20px 0;
  width: 100%;
}
.btn-box {
  text-align: right;
}

::v-deep .file_list {
  .is-leaf {
    color: #333;
    background-color: #f5f5f5;
  }
}

::v-deep .foot_page {
  margin-top: 20px;
  text-align: right;

  .el-pagination__total {
    float: left;
  }
}
</style>